import "./ProyectosCommon.css";
import { BasePageComponent } from "../../../shared/components/pages/BasePageComponent";
import { categoriaColor } from "../../../shared/utils/categoriaColors";
import { CatalogoItemResponse } from "../../../shared/response/proyectos/CatalogoItemResponse";
import { CultivoResponse } from "../../../shared/response/proyectos/CultivoResponse";
import { FaseResponse } from "../../../shared/response/proyectos/FaseResponse";
import { CatalogoService } from "../../services/proyectos/CatalogoService";
import { CultivoService } from "../../services/proyectos/CultivoService";
import { FaseService } from "../../services/proyectos/FaseService";
import { CatalogoItemDeleteService } from "../../services/proyectos/CatalogoItemDeleteService";
import { CatalogoPrecioModal } from "./CatalogoPrecioModal";
import { CatalogoItemFormModal } from "./CatalogoItemFormModal";
import { ConfirmDialogComponent } from "../../../shared/components/ConfirmDialogComponent";
import { errorMessageComponent } from "../../../shared/components/error/ErrorMessageComponent";
import { fmtCentavos } from "../../../shared/utils/proyectosFormat";

const TIPOP_LABEL: Record<string, string> = { smmlv: "SMMLV", ipc: "IPC", fijo: "Fijo", volatil: "Volátil" };
const INCL_LABEL: Record<string, string> = { obligatorio: "Obligatorio", incluido: "Incluido", opcional: "Opcional" };

export class CatalogoPage extends BasePageComponent {
  private _cultivos: CultivoResponse[] = [];
  private _fases: FaseResponse[] = [];
  private _items: CatalogoItemResponse[] = [];
  private _filtered: CatalogoItemResponse[] = [];
  private _cultivoId = "";

  private _cultivoSel!: HTMLSelectElement;
  private _tipoSel!:    HTMLSelectElement;
  private _faseSel!:    HTMLSelectElement;
  private _search!:     HTMLInputElement;
  private _tbody!:      HTMLTableSectionElement;
  private _totEl!:      HTMLSpanElement;

  public getAppRoute(): string { return "/proyectos/catalogo"; }
  public getPageTitle(): string | null { return "Proyectos"; }

  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.className = "sx-page pr-page";
    pageContent.innerHTML = `
      <div class="pr-content">
        <div class="pr-pg-hd">
          <div>
            <div class="pr-pg-ey">Proyectos · Configuración</div>
            <div class="pr-pg-ti">Catálogo de costos</div>
            <div class="pr-pg-su">Estructura de ítems CAPEX/OPEX por cultivo. El precio vigente se calcula con el snapshot activo.</div>
          </div>
          <button class="sx-btn sx-btn-primary sx-btn-sm" id="cat-nuevo" disabled><i class="ph ph-plus"></i> Nuevo ítem</button>
        </div>

        <div class="pr-frow">
          <select class="pr-fsel" id="cat-cultivo"><option value="">Selecciona un cultivo…</option></select>
          <select class="pr-fsel" id="cat-tipo">
            <option value="">CAPEX + OPEX</option>
            <option value="CAPEX">Solo CAPEX</option>
            <option value="OPEX">Solo OPEX</option>
          </select>
          <select class="pr-fsel" id="cat-fase">
            <option value="">Todas las fases</option>
            <option value="F0">F0 · Establecimiento</option>
            <option value="F1">F1 · Levante</option>
            <option value="F2">F2 · Producción</option>
          </select>
          <div class="pr-sw">
            <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
            <input class="pr-si" id="cat-search" placeholder="Buscar ítem…">
          </div>
          <span class="pr-ftot" id="cat-tot"></span>
        </div>

        <div class="pr-tbl-wrap">
          <table class="pr-tbl">
            <thead>
              <tr>
                <th>Ítem</th><th>Categoría</th><th>Unidad</th><th>Cant.</th><th>Frec.</th>
                <th>Tipo precio</th><th>Precio ref. → vigente</th><th>Activo</th><th></th>
              </tr>
            </thead>
            <tbody id="cat-tbody"><tr><td colspan="9" class="pr-empty">Selecciona un cultivo para ver su catálogo.</td></tr></tbody>
          </table>
        </div>
      </div>
    `;

    this._cultivoSel = document.getElementById("cat-cultivo")! as HTMLSelectElement;
    this._tipoSel    = document.getElementById("cat-tipo")! as HTMLSelectElement;
    this._faseSel    = document.getElementById("cat-fase")! as HTMLSelectElement;
    this._search     = document.getElementById("cat-search")! as HTMLInputElement;
    this._tbody      = document.getElementById("cat-tbody")! as HTMLTableSectionElement;
    this._totEl      = document.getElementById("cat-tot")!;

    this._cultivoSel.onchange = () => {
      this._cultivoId = this._cultivoSel.value;
      document.getElementById("cat-nuevo")!.toggleAttribute("disabled", !this._cultivoId);
      void this._loadCatalogo();
    };
    this._tipoSel.onchange = () => this._filterAndRender();
    this._faseSel.onchange = () => this._filterAndRender();
    this._search.oninput = () => this._filterAndRender();
    document.getElementById("cat-nuevo")!.addEventListener("click", () => this._onCreate());

    void this._loadCultivos();
    void this._loadFases();
  }

  protected override beforeDispose(): void {}

  private async _loadCultivos(): Promise<void> {
    try {
      this._cultivos = (await CultivoService.instance.get())
        .filter((c) => !c.isEliminado).sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._cultivoSel.innerHTML = `<option value="">Selecciona un cultivo…</option>` +
        this._cultivos.map((c) => `<option value="${c.id}">${this._esc(c.nombre)} · ${c.mesesACosecha} m</option>`).join("");
    } catch (error) {
      errorMessageComponent.addError("Error al cargar cultivos", (error as Error).message);
    }
  }

  private async _loadFases(): Promise<void> {
    try {
      this._fases = (await FaseService.instance.get())
        .filter((f) => !f.isEliminado).sort((a, b) => a.orden - b.orden);
    } catch (error) {
      errorMessageComponent.addError("Error al cargar fases", (error as Error).message);
    }
  }

  private async _loadCatalogo(): Promise<void> {
    if (!this._cultivoId) {
      this._items = [];
      this._tbody.innerHTML = `<tr><td colspan="9" class="pr-empty">Selecciona un cultivo para ver su catálogo.</td></tr>`;
      this._totEl.textContent = "";
      return;
    }
    this._tbody.innerHTML = `<tr><td colspan="9" class="pr-empty">Cargando…</td></tr>`;
    try {
      this._items = await CatalogoService.instance.getByCultivoId(this._cultivoId);
      this._items.sort((a, b) => (a.sec || "").localeCompare(b.sec || "") || (a.sub || "").localeCompare(b.sub || "") || a.nombre.localeCompare(b.nombre));
      this._filterAndRender();
    } catch (error) {
      errorMessageComponent.addError("Error al cargar el catálogo", (error as Error).message);
      this._tbody.innerHTML = `<tr><td colspan="9" class="pr-empty">Error al cargar</td></tr>`;
    }
  }

  private _filterAndRender(): void {
    const q = this._search.value.toLowerCase().trim();
    const ft = this._tipoSel.value;
    const ff = this._faseSel.value;
    this._filtered = this._items.filter((it) => {
      const matchQ = !q || it.nombre.toLowerCase().includes(q) || (it.categoria || "").toLowerCase().includes(q);
      const matchT = !ft || it.tipo === ft;
      const matchF = !ff || it.faseCodigo === ff;
      return matchQ && matchT && matchF;
    });
    this._render();
  }

  private _render(): void {
    const list = this._filtered;
    this._totEl.textContent = this._cultivoId ? `${list.length} ítem${list.length === 1 ? "" : "s"}` : "";
    if (!this._cultivoId) return;
    if (list.length === 0) {
      this._tbody.innerHTML = `<tr><td colspan="9" class="pr-empty">Sin ítems para este cultivo.</td></tr>`;
      return;
    }

    let lastSub = "";
    const rows: string[] = [];
    for (let i = 0; i < list.length; i++) {
      const it = list[i];
      if (it.sub !== lastSub) {
        lastSub = it.sub;
        const faseTag = it.faseCodigo ? `${it.faseCodigo} · ` : "";
        rows.push(`<tr><td colspan="9" style="background:var(--sx-bg-subtle);font-weight:var(--sx-weight-semibold);font-size:var(--sx-text-xs);color:var(--sx-text-secondary);text-transform:uppercase;letter-spacing:0.04em">${faseTag}${this._esc(it.tipo)} · ${this._esc(it.sub || "—")}</td></tr>`);
      }
      const precio = it.precioReferencial != null
        ? `${fmtCentavos(it.precioReferencial)}${it.precioVigente != null ? ` <span style="color:var(--sx-text-tertiary)">→ ${fmtCentavos(it.precioVigente)}</span>` : ""}`
        : `<span style="color:var(--sx-text-tertiary)">Sin precio</span>`;
      const editable = it.tipoP === "ipc" || it.tipoP === "fijo" || it.tipoP === "volatil";
      const esObligatorio = it.incl === "obligatorio";
      const freqTxt = it.freq === 1 ? "1" : `${it.freq}${it.freqUnidad ? " " + this._esc(it.freqUnidad) : ""}`;
      rows.push(`
        <tr style="${it.activo ? "" : "opacity:.5"}">
          <td>
            ${esObligatorio ? `<i class="ph ph-lock-simple" title="Obligatorio" style="color:var(--sx-text-tertiary);margin-right:4px"></i>` : ""}
            <span style="${esObligatorio ? `font-weight:var(--sx-weight-semibold)` : ""}">${this._esc(it.nombre)}</span>
            ${it.nitro ? ` <span class="pr-pill blue" style="font-size:10px">NITRO</span>` : ""}
            ${it.incl === "opcional" ? ` <span class="pr-pill am" style="font-size:10px">${INCL_LABEL.opcional}</span>` : ""}
          </td>
          <td style="color:var(--sx-text-tertiary)">${it.categoria ? `<span class="pr-cat-dot" style="background:${categoriaColor(it.categoria)}"></span>` : ""}${this._esc(it.categoria || "—")}</td>
          <td style="color:var(--sx-text-tertiary)">${this._esc(it.unidad || "—")}</td>
          <td class="pr-num">${it.cantidadPorHa} <span style="color:var(--sx-text-tertiary)">${this._esc(it.cantUnidad || "")}</span></td>
          <td class="pr-num">${freqTxt}</td>
          <td><span class="pr-pill na">${TIPOP_LABEL[it.tipoP] ?? it.tipoP}</span></td>
          <td class="pr-num">${precio}</td>
          <td>${it.activo ? `<span class="pr-pill ok">Sí</span>` : `<span class="pr-pill na">No</span>`}</td>
          <td>
            <div class="pr-actions">
              ${editable ? `<button class="sx-btn sx-btn-ghost sx-btn-sm" data-act="precio" data-id="${it.id}">Precio</button>` : ""}
              <button class="sx-btn sx-btn-ghost sx-btn-sm" data-act="toggle" data-id="${it.id}">${it.activo ? "Desactivar" : "Activar"}</button>
              <button class="sx-btn sx-btn-ghost sx-btn-icon sx-btn-sm" data-act="editar" data-id="${it.id}" title="Editar ítem"><i class="ph ph-pencil-simple"></i></button>
              <button class="sx-btn sx-btn-ghost sx-btn-icon sx-btn-sm" data-act="eliminar" data-id="${it.id}" title="Eliminar ítem"><i class="ph ph-trash"></i></button>
            </div>
          </td>
        </tr>`);
    }
    this._tbody.innerHTML = rows.join("");

    this._tbody.querySelectorAll<HTMLButtonElement>("button[data-act]").forEach((btn) => {
      const it = this._items.find((x) => x.id === btn.dataset.id)!;
      btn.onclick = () => {
        if (btn.dataset.act === "precio")    void this._onPrecio(it);
        if (btn.dataset.act === "toggle")    void this._onToggle(it);
        if (btn.dataset.act === "editar")    this._onEdit(it);
        if (btn.dataset.act === "eliminar")  void this._onDelete(it);
      };
    });
  }

  private _onPrecio(it: CatalogoItemResponse): void {
    new CatalogoPrecioModal(it, (saved) => this._replace(saved)).init();
  }

  private _categoriasSugeridas(): string[] {
    return [...new Set(this._items.map((it) => it.categoria).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  }

  private _subsSugeridas(): string[] {
    return [...new Set(this._items.map((it) => it.sub).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  }

  private _onCreate(): void {
    if (!this._cultivoId) return;
    new CatalogoItemFormModal(this._cultivoId, this._fases, this._categoriasSugeridas(), this._subsSugeridas(), (saved) => this._replace(saved)).init();
  }

  private _onEdit(it: CatalogoItemResponse): void {
    new CatalogoItemFormModal(this._cultivoId, this._fases, this._categoriasSugeridas(), this._subsSugeridas(), (saved) => this._replace(saved), it).init();
  }

  private async _onDelete(it: CatalogoItemResponse): Promise<void> {
    new ConfirmDialogComponent({
      title: "Eliminar ítem del catálogo",
      message: `¿Eliminar "${it.nombre}"? Solo se puede si ningún proyecto lo usa. Si ya se usó en algún proyecto, desactívalo en su lugar.`,
      confirmLabel: "Eliminar",
      onConfirm: async () => {
        try {
          await new CatalogoItemDeleteService().delete(it.id);
          this._items = this._items.filter((x) => x.id !== it.id);
          this._filterAndRender();
        } catch (error) {
          errorMessageComponent.addError("Error al eliminar", (error as Error).message);
        }
      },
    }).init();
  }

  private async _onToggle(it: CatalogoItemResponse): Promise<void> {
    try {
      const saved = await CatalogoService.instance.toggleActivo(it.id);
      this._replace(saved);
    } catch (error) {
      errorMessageComponent.addError("Error al cambiar estado", (error as Error).message);
    }
  }

  /** Reemplaza el ítem si ya estaba (editar/precio/toggle) o lo agrega si es nuevo (crear). */
  private _replace(saved: CatalogoItemResponse): void {
    const existe = this._items.some((x) => x.id === saved.id);
    this._items = existe
      ? this._items.map((x) => (x.id === saved.id ? saved : x))
      : [...this._items, saved];
    this._filterAndRender();
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
}
